import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NewQuickWorkoutPage } from './new-quick-workout.page';

const routes: Routes = [
  {
    path: '',
    component: NewQuickWorkoutPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewQuickWorkoutPageRoutingModule {}
